import React, { Fragment, useContext, useState } from "react";
import "../styles/blogs.css";
import HelmetComponent from "../components/HelmetComponent";
import { WebsiteContext } from "../context/AppContext";
import { blogData } from "../data/BlogData";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const { isMobileView, color, loading } = useContext(WebsiteContext);
  const [loadings, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleOpenBlogDetails = (id) => {
     setLoading(true)
    setTimeout(() => {
      setLoading(false)
       navigate(`/blog-details/${id}`);
    }, 1000);
   
  };
   if (loading){
    return <div className="loader_container"><span class="loader"></span></div>
  }
  return (
    <Fragment>
      <HelmetComponent
        title="Blogs | SSS COVAI TRAVEL'S"
        name="description"
        content="Know the Road safeties and travles to explore the travles with happiness"
      />
      <div
        className={isMobileView ? "terms_title_mobile" : "terms_title"}
        style={{ color: color }}
      >
        Blogs
      </div>
      {loadings && <div className="loader_container"><span class="loader"></span></div>}
      {!loadings && 
      <div style={{marginBottom:100}}>
       {blogData?.map((data, index) => {
        return (
          <div key={index} onClick={()=>handleOpenBlogDetails(data?.id)} style={{cursor:"pointer", borderBottom: index !== blogData.length - 1 && "1px dashed black", padding: "0px 16px"}}>
            <div
              className={isMobileView ? "terms_title_mobile" : "terms_title"}
              style={{ color: color, fontSize: isMobileView ? 20 : 28 }}
            >
              {data?.titile}
            </div>
            <div style={{display:"flex", justifyContent:"center", alignContent:"center", alignSelf:"center", marginBottom:40}}><img src={data?.image} alt='cover' style={{height:400, width:"auto", }}/></div>
            <div
              className={
                isMobileView ? "terms_subtitle_mobile" : "terms_subtitle"
              }
              style={{ color: color, marginBottom:24 }}
            >
              {data?.subtitle}
            </div>
           
          </div>
        );
      })}
      </div>}
     
    </Fragment>
  );
};

export default Blog;
